import React from 'react';
import Icon from '@ant-design/icons';
/** type imports */
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

const HeartSvg = () => (
  <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
    <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
  </svg>
);

const PandaSvg = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
    <path
      d="M99.096 315.634s-82.58-64.032-82.58-132.13c0-66.064 33.032-165.162 148.646-148.646 83.37 11.91 99.096 165.162 99.096 165.162l-165.162 115.614zM924.906 315.634s82.58-64.032 82.58-132.13c0-66.064-33.032-165.162-148.646-148.646-83.37 11.91-99.096 165.162-99.096 165.162l165.162 115.614z"
      fill="#6B676E"
      p-id="1143"
    />
    <path
      d="M1024 561.548c0 264.526-229.23 429.42-512.002 429.42S0 826.076 0 561.548 283.96 66.064 512.002 66.064 1024 297.022 1024 561.548z"
      fill="#FFEBD2"
      p-id="1144"
    />
    <path
      d="M330.324 842.126c0 82.096 81.34 148.646 181.678 148.646s181.678-66.55 181.678-148.646H330.324z"
      fill="#E9D7C3"
      p-id="1145"
    />
    <path
      d="M644.13 611.098C594.582 528.516 561.55 512 512.002 512c-49.548 0-82.58 16.516-132.13 99.096-42.488 70.814-78.73 211.264-49.548 247.742 66.064 82.58 165.162 33.032 181.678 33.032 16.516 0 115.614 49.548 181.678-33.032 29.18-36.476-7.064-176.93-49.55-247.74z"
      fill="#FFFFFF"
      p-id="1146"
    />
    <path
      d="M611.098 495.484c0-45.608 36.974-82.58 82.58-82.58 49.548 0 198.194 99.098 198.194 165.162s-79.934 144.904-148.646 99.096c-49.548-33.032-132.128-148.646-132.128-181.678zM412.904 495.484c0-45.608-36.974-82.58-82.58-82.58-49.548 0-198.194 99.098-198.194 165.162s79.934 144.904 148.646 99.096c49.548-33.032 132.128-148.646 132.128-181.678z"
      fill="#6B676E"
      p-id="1147"
    />
    <path
      d="M512.002 726.622c-30.06 0-115.614 5.668-115.614 33.032 0 49.638 105.484 85.24 115.614 82.58 10.128 2.66 115.614-32.944 115.614-82.58-0.002-27.366-85.556-33.032-115.614-33.032z"
      fill="#464655"
      p-id="1148"
    />
    <path
      d="M330.324 495.484m-33.032 0a33.032 33.032 0 1 0 66.064 0 33.032 33.032 0 1 0-66.064 0Z"
      fill="#464655"
      p-id="1149"
    />
    <path
      d="M693.678 495.484m-33.032 0a33.032 33.032 0 1 0 66.064 0 33.032 33.032 0 1 0-66.064 0Z"
      fill="#464655"
      p-id="1150"
    />
  </svg>
);

const WaitingSVG = () => (
  <svg id="Capa_1" viewBox="0 0 512 512" width="1em" height="1em" fill="currentColor">
    <g>
      <g>
        <path d="M211,0c-33.084,0-60,26.916-60,60s26.916,60,60,60s60-26.916,60-60S244.084,0,211,0z M211,90c-16.542,0-30-13.458-30-30
			s13.458-30,30-30s30,13.458,30,30S227.542,90,211,90z"/>
      </g>
    </g>
    <g>
      <g>
        <path d="M407,0c-57.897,0-105,47.103-105,105s47.103,105,105,105c57.897,0,105-47.103,105-105C512,47.103,464.897,0,407,0z
			 M407,180c-41.355,0-75-33.645-75-75s33.645-75,75-75c41.355,0,75,33.645,75,75S448.355,180,407,180z"/>
      </g>
    </g>
    <g>
      <g>
        <path d="M437,90h-15V75c0-8.284-6.716-15-15-15s-15,6.716-15,15v30c0,8.284,6.716,15,15,15h30c8.284,0,15-6.716,15-15
			S445.284,90,437,90z"/>
      </g>
    </g>
    <g>
      <g>
        <path d="M347,271h-76v-91c0-33.084-26.916-60-60-60s-60,26.916-60,60v136c0,5.258,0.915,10.307,2.58,15.001h-39.089
			c0,0-15.972-127.732-24.502-197.011C89.45,109.641,69.476,90,45,90c-24.813,0-45,20.187-45,45c0,0.619,0.039,1.238,0.115,1.853
			l29.896,240.169C30.44,396.134,42.846,412.339,60,418.423V497c0,8.284,6.716,15,15,15s15-6.716,15-15v-76h121v76
			c0,8.284,6.716,15,15,15s15-6.716,15-15v-78.58c17.459-6.192,30-22.865,30-42.42c0-5.258-0.915-10.305-2.58-15H302v106
			c0,24.813,20.187,45,45,45s45-20.187,45-45V316C392,291.187,371.813,271,347,271z M226,391H75c-8.271,0-15-6.729-15-15
			c0-1.403,1.63,12.164-29.98-241.772C30.423,126.314,36.988,120,45,120c8.271,0,15,6.729,15,15
			c0,1.87,26.365,212.858,26.365,212.858C87.304,355.365,93.685,361,101.25,361c5.932,0,117.936,0,124.75,0c8.271,0,15,6.729,15,15
			S234.271,391,226,391z M362,467c0,8.271-6.729,15-15,15s-15-6.729-15-15V346c0-8.284-6.716-15-15-15c-4.283,0-114.149,0-121.01,0
			c-8.267-0.006-14.99-6.732-14.99-15V180c0-16.542,13.458-30,30-30s30,13.458,30,30v106c0,8.284,6.716,15,15,15h91
			c8.271,0,15,6.729,15,15V467z"/>
      </g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
  </svg>
);

const LiveStreamingSVG = () => (
  <svg viewBox="-16 0 512 512.00113"  width="1em" height="1em" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><g><path d="m262.84375 140.558594c-12.699219 12.671875-33.28125 12.671875-45.980469 0-12.695312-12.671875-12.695312-33.21875 0-45.890625 12.699219-12.671875 33.28125-12.671875 45.980469 0 12.695312 12.671875 12.695312 33.21875 0 45.890625zm0 0" /><path d="m307.257812 189.726562c-3.960937 0-7.921874-1.511718-10.9375-4.539062-6.03125-6.039062-6.019531-15.824219.019532-21.851562 12.238281-12.214844 18.976562-28.453126 18.976562-45.722657s-6.738281-33.507812-18.976562-45.722656c-6.039063-6.03125-6.050782-15.8125-.019532-21.855469 6.027344-6.039062 15.8125-6.050781 21.851563-.019531 18.089844 18.054687 28.050781 42.058594 28.050781 67.597656 0 25.535157-9.960937 49.542969-28.050781 67.597657-3.015625 3.011718-6.964844 4.515624-10.914063 4.515624zm0 0" /><path d="m342.210938 235.222656c-3.960938 0-7.921876-1.511718-10.9375-4.535156-6.03125-6.042969-6.019532-15.824219.019531-21.855469 24.414062-24.367187 37.863281-56.761719 37.863281-91.21875s-13.449219-66.851562-37.863281-91.21875c-6.039063-6.03125-6.050781-15.8125-.019531-21.855469 6.03125-6.039062 15.8125-6.050781 21.851562-.019531 30.265625 30.207031 46.9375 70.371094 46.933594 113.09375 0 42.722657-16.667969 82.890625-46.933594 113.097657-3.015625 3.007812-6.964844 4.511718-10.914062 4.511718zm0 0" /><path d="m172.371094 189.726562c-3.949219 0-7.898438-1.503906-10.917969-4.515624-18.089844-18.054688-28.050781-42.0625-28.050781-67.597657 0-25.539062 9.960937-49.542969 28.050781-67.597656 6.039063-6.03125 15.824219-6.023437 21.851563.019531 6.03125 6.039063 6.019531 15.824219-.019532 21.855469-12.238281 12.214844-18.976562 28.453125-18.976562 45.722656s6.738281 33.507813 18.976562 45.722657c6.039063 6.027343 6.050782 15.8125.019532 21.851562-3.015626 3.023438-6.976563 4.539062-10.933594 4.539062zm0 0" /><path d="m137.417969 235.222656c-3.953125 0-7.902344-1.503906-10.917969-4.515625-30.265625-30.207031-46.933594-70.371093-46.933594-113.09375 0-42.726562 16.667969-82.890625 46.933594-113.097656 6.039062-6.027344 15.824219-6.019531 21.851562.023437 6.03125 6.039063 6.019532 15.820313-.019531 21.851563-24.414062 24.367187-37.863281 56.761719-37.863281 91.21875s13.449219 66.855469 37.863281 91.222656c6.039063 6.03125 6.050781 15.8125.019531 21.855469-3.015624 3.023438-6.976562 4.535156-10.933593 4.535156zm0 0" /><path d="m443.480469 261.9375h-407.332031c-19.964844 0-36.148438 16.183594-36.148438 36.144531v177.769531c0 19.964844 16.183594 36.148438 36.148438 36.148438h407.328124c19.964844 0 36.148438-16.183594 36.148438-36.148438v-177.769531c0-19.960937-16.183594-36.144531-36.144531-36.144531zm-324.609375 203.683594h-56.933594c-8.53125 0-15.449219-6.917969-15.449219-15.453125v-126.398438c0-8.53125 6.917969-15.453125 15.449219-15.453125 8.535156 0 15.453125 6.917969 15.453125 15.453125v110.945313h41.480469c8.535156 0 15.453125 6.917968 15.453125 15.453125 0 8.535156-6.917969 15.453125-15.453125 15.453125zm63.328125-15.453125c0 8.535156-6.917969 15.453125-15.453125 15.453125s-15.453125-6.917969-15.453125-15.453125v-126.398438c0-8.53125 6.917969-15.453125 15.453125-15.453125s15.453125 6.917969 15.453125 15.453125zm130.015625-121.929688-38.160156 126.394531c-.003907.011719-.007813.023438-.011719.035157-4.144531 14.144531-25.273438 13.796875-29.5625 0-.003907-.011719-.007813-.023438-.011719-.035157l-38.160156-126.394531c-2.464844-8.171875 2.15625-16.792969 10.328125-19.261719 8.164062-2.464843 16.792969 2.15625 19.257812 10.328126l23.367188 77.394531 23.367187-77.394531c2.46875-8.171876 11.089844-12.796876 19.261719-10.328126 8.167969 2.46875 12.792969 11.089844 10.324219 19.261719zm95.066406 35.320313c8.535156 0 15.453125 6.917968 15.453125 15.453125 0 8.53125-6.917969 15.453125-15.453125 15.453125h-43.851562v40.25h52.175781c8.535156 0 15.453125 6.917968 15.453125 15.453125 0 8.535156-6.917969 15.453125-15.453125 15.453125h-67.628907c-8.535156 0-15.453124-6.917969-15.453124-15.453125v-126.398438c0-8.53125 6.917968-15.453125 15.453124-15.453125h69.710938c8.53125 0 15.453125 6.917969 15.453125 15.453125 0 8.535157-6.921875 15.453125-15.453125 15.453125h-54.261719v24.335938zm0 0" /></g></svg>
);

const VisibilityOffSVG = () => (
  <svg version="1.1"  width="1em" height="1em" fill="currentColor" viewBox="0 0 558.45 558.45">
<g>
	<g id="visibility-off">
		<path d="M280.5,138.975c71.4,0,127.5,56.1,127.5,127.5c0,15.3-2.55,33.15-10.2,45.9l73.95,73.949
			c38.25-33.149,68.85-73.949,86.7-119.85c-43.351-112.2-153-191.25-280.5-191.25c-35.7,0-68.85,7.65-102,17.85l56.1,56.1
			C247.35,141.525,265.2,138.975,280.5,138.975z M25.5,70.125l58.65,58.65l10.2,10.2c-43.35,33.15-76.5,76.5-94.35,127.5
			c43.35,112.2,153,191.25,280.5,191.25c38.25,0,76.5-7.65,112.2-20.4l10.2,10.2l73.949,73.95l33.15-33.15L58.65,36.975L25.5,70.125
			z M165.75,210.375l38.25,38.25c0,7.65,0,12.75,0,17.85c0,43.35,33.15,76.5,76.5,76.5c5.1,0,10.2,0,17.85-2.55l38.25,38.25
			c-17.85,10.2-35.699,15.3-56.1,15.3c-71.4,0-127.5-56.1-127.5-127.5C153,246.075,158.1,228.225,165.75,210.375z M275.4,189.975
			l79.05,79.05c0-2.55,0-2.55,0-5.1c0-43.35-33.15-76.5-76.5-76.5C277.95,189.975,277.95,189.975,275.4,189.975z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
);

export const HeartIcon: React.FC<Partial<CustomIconComponentProps>> = (props: Partial<CustomIconComponentProps>) => <Icon component={HeartSvg} {...props} />;

export const PandaIcon: React.FC<Partial<CustomIconComponentProps>> = (props: Partial<CustomIconComponentProps>) => <Icon component={PandaSvg} {...props} />;

export const WaitingIcon: React.FC<Partial<CustomIconComponentProps>> = (props: Partial<CustomIconComponentProps>) => <Icon component={WaitingSVG} {...props} />;
export const LiveStreamingIcon: React.FC<Partial<CustomIconComponentProps>> = (props: Partial<CustomIconComponentProps>) => <Icon component={LiveStreamingSVG} {...props} />;
export const VisibilityOffIcon: React.FC<Partial<CustomIconComponentProps>> = (props: Partial<CustomIconComponentProps>) => <Icon component={VisibilityOffSVG} {...props} />;